import { Link } from "react-router-dom";
import React, { useState } from "react";
const ErvaringenMenu = ({ token, username }) => {
  const [isActive, setIsActive] = useState(false);
  if (username.bedrijf && username.bedrijf.modules.includes("ervaringen")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker" || token.role === "ervaringeigenaar") {
      return (
        <li className="treeview">
          <a className="cursurhand" onClick={() => setIsActive(!isActive)}>
            <i className="fa fa-solid fa-torii-gate"></i>
            <span>Beheer Ervaringen</span>
            <span className="pull-right-container">
              <i className="fa fa-angle-left pull-right" />
            </span>
          </a>
          <ul className={isActive ? "treeview-menu menu-open" : "treeview-menu "}>
            <li>
              <Link to="/ervaringen" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-warehouse" />
                <span>Ervaringen</span>
              </Link>
            </li>
            {token.role === "admin" ||
              token.role === "manager" ||
              token.role === "medewerker" && (
                <li>
                  <Link to="/ervaringen/toevoegen" onClick={() => setIsActive(!isActive)}>
                    <i className="fa fa-utensils" />
                    <span>Ervaringen Toevoegen</span>
                  </Link>
                </li>
              )}
          </ul>
        </li>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default ErvaringenMenu;
